import script from "./AsosTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./AsosTabs.vue?vue&type=script&setup=true&lang=js"

import "./AsosTabs.vue?vue&type=style&index=0&id=60f2148c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f2148c"]])

export default __exports__